// ВАЛИДАЦИЯ ВСЕЙ ФОРМЫ
export default function validateForm(form) {
    const inputs = form.querySelectorAll("input[data-field], textarea[data-field]");
    let isFormValid = true;

    clearErrors(form);

    inputs.forEach(input => {
        const fieldName = input.dataset.field;
        const fieldConfig = typeof FORM_FIELDS !== "undefined" && FORM_FIELDS.fields && FORM_FIELDS.fields[fieldName];

        if (fieldConfig) {
            const validationRules = fieldConfig.validation;
            const errorMessage = fieldConfig.error;

            if (validationRules && !validateField(input, validationRules)) {
                onError(input.nextElementSibling, input.parentNode, errorMessage);
                isFormValid = false;
            } else {
                onSuccess(input.nextElementSibling, input.parentNode);
            }
        }
    });

    return isFormValid;
}

// УНИВЕРСАЛЬНАЯ ВАЛИДАЦИЯ ПОЛЯ НА ОСНОВЕ ПРАВИЛ
function validateField(input, rules) {
    const value = input.value.trim();

    // Проверка обязательности
    if (rules.required && value === "") {
        return false;
    }

    // Если поле пустое и не обязательное - валидно
    if (!rules.required && value === "") {
        return true;
    }

    // Проверка паттерна (БЕЗ toLowerCase для корректной валидации)
    if (rules.pattern && !new RegExp(rules.pattern, "i").test(value)) {
        return false;
    }

    // Проверка минимальной длины
    if (rules.minLength && value.length < rules.minLength) {
        return false;
    }

    // Проверка максимальной длины
    if (rules.maxLength && value.length > rules.maxLength) {
        return false;
    }

    // Кастомные валидаторы для специфичных типов полей
    if (rules.type) {
        return validateByType(value, rules.type, rules);
    }

    return true;
}

// СПЕЦИФИЧНЫЕ ВАЛИДАТОРЫ ДЛЯ РАЗНЫХ ТИПОВ ПОЛЕЙ
function validateByType(value, type, rules) {
    const validators = {
        name: val => /^[a-zA-Zа-яА-ЯёЁ.\s-]+$/i.test(val),
        phone: val => /^(\s*)?(\+)?([- _():+]?\d[- _():+]?){10,14}(\s*)?$/.test(val),
        email: val => /^[^\s@]+@[^\s@]+\.[^\s@]+$/i.test(val),
        message: val => val.length <= (rules.maxLength || 3000),
        number: val => !isNaN(val) && !isNaN(parseFloat(val)),
        url: val => {
            try {
                new URL(val);
                return true;
            } catch {
                return false;
            }
        },
        text: () => true, // Текстовые поля всегда валидны если прошли базовые проверки
    };

    return validators[type] ? validators[type](value) : true;
}

// ВСПОМОГАТЕЛЬНЫЕ ФУНКЦИИ ДЛЯ УПРАВЛЕНИЯ ОШИБКАМИ
function onError(element, parentEl, message) {
    parentEl.classList.add("error");
    if (element) element.textContent = message;
}

function onSuccess(element, parentEl) {
    parentEl.classList.remove("error");
    if (element) element.textContent = "";
}

function clearErrors(form) {
    // Очищаем все сообщения об ошибках
    const errorMessages = form.querySelectorAll(".field-error");
    errorMessages.forEach(message => (message.textContent = ""));

    // Убираем классы ошибок с родительских элементов
    const errorElements = form.querySelectorAll(".form-item.error");
    errorElements.forEach(element => element.classList.remove("error"));
}

function clearErrorsForInput(input) {
    const errorMessage = input.nextElementSibling;
    if (errorMessage && errorMessage.classList.contains("field-error")) {
        errorMessage.textContent = "";
        input.parentNode.classList.remove("error");
    }
}

// ЭКСПОРТИРУЕМ ФУНКЦИИ ДЛЯ REAL-TIME ВАЛИДАЦИИ
export { validateField, clearErrorsForInput };
